module.exports = __webpack_public_path__ + "img/组1.8f58e928.png";